import { render, staticRenderFns } from "./MandatsRetraitNews.vue?vue&type=template&id=1f70c052&"
import script from "./MandatsRetraitNews.vue?vue&type=script&lang=js&"
export * from "./MandatsRetraitNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports